import { createContext } from "react";
import { LayoutGrid } from "../ReactPageLayout/LayoutGrid";
export const LayoutComponents = {
    LayoutGrid,
};
/**
 * Context for injecting a different set of components for rendering layout grid
 */
export const LayoutComponentContext = createContext(LayoutComponents);
LayoutComponentContext.displayName = "LayoutComponentContext";
//# sourceMappingURL=LayoutComponentContext.js.map